import { all, takeLatest } from 'redux-saga/effects';

import { getMemberByMobileAction } from '@/redux/actions';

import { getMemberByMobileSaga } from './get-member-by-mobile';

export default function* root(): Generator {
  yield all([takeLatest(getMemberByMobileAction.request.type, getMemberByMobileSaga)]);
}
